import React from 'react';
import PendingAuditionSlider from '../PendingAuditionSlider/PendingAuditionSlider';
import { useHistory } from "react-router-dom";
import AdminAuditionNav from '../AdminAuditionNav/AdminAuditionNav';


const PendingAudition = () => {
   

    return (
        <>
        <AdminAuditionNav/>
        <div className="card card-bg mt-3 py-2">
            <div className="d-flex px-4 pt-3">
                <div className="faTrophy"><i className="fas fa-trophy"></i></div>
                <h4 className="mx-3 text-white p-2">Pending Auditions</h4>
            </div>

            <div className="">
                <PendingAuditionSlider />
            </div>

        </div>
    </>
    );
};

export default PendingAudition;